
import { Component, Vue, Watch, Prop } from "vue-property-decorator"

@Component({})
export default class StepProgress extends Vue {
	@Prop({ type: Number, default: 1 })
	currentStep!: number

	@Prop({ type: Number, default: 1 })
	stepCount!: number

	@Prop({ default: () => null })
	stepTitle!: string | null

	get steps () {
		const steps = []

		for (let i = 0; i < this.stepCount; i++) {
			steps.push({
				index: i
			})
		}

		return steps
	}

	get stepStyle () {
		const stepPercent = 100 / this.stepCount
		return {
			width: `calc(${stepPercent}% - 4px)`
		}
	}
}

